/**
 * JavaScript routing module
 * Generates URLs from route names using data injected by PHP
 *
 * Usage:
 *   import { generateRoute } from './routing/router.js';
 *   const url = generateRoute('app_user_game_save_game_data');
 */

/**
 * Generate URL from route name and parameters
 *
 * @param {string} name - Route name (e.g., 'app_user_game_save_game_data')
 * @param {Object} params - Route parameters for path substitution and query string
 * @param {Object} options - Generation options (absolute: bool)
 * @returns {string|null} Generated URL or null if route not found
 */
export function generateRoute(name, params = {}, options = {}) {
    if (!window.__ROUTES__) {
        console.error('Routes data not available. Ensure $_jsRoutes is included in template.');
        return null;
    }

    const routes = window.__ROUTES__;

    if (!routes[name]) {
        console.error(`Route "${name}" not found. Available routes:`, Object.keys(routes));
        return null;
    }

    const route = routes[name];
    let url = route.path;
    const queryParams = [];

    // Replace path tokens (:param)
    for (const [key, value] of Object.entries(params)) {
        const token = `:${key}`;
        if (url.includes(token)) {
            url = url.replace(token, encodeURIComponent(value));
        } else {
            // Not a path param, add to query string
            queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
    }

    // Append query string
    if (queryParams.length > 0) {
        url += '?' + queryParams.join('&');
    }

    // Make absolute if requested
    if (options.absolute && window.location) {
        url = window.location.origin + url;
    }

    return url;
}

/**
 * Get list of all available route names
 * @returns {string[]} Array of route names
 */
export function getAvailableRoutes() {
    if (!window.__ROUTES__) {
        return [];
    }
    return Object.keys(window.__ROUTES__);
}
